import { useMemo } from 'react'
import { CustomFieldValue } from '../context/CustomField/CustomFieldTypes'

interface UseTransformFieldValuesMapProps {
    data: Array<CustomFieldValue>
}

export default function useTransformFieldValuesMap ({ data }:  UseTransformFieldValuesMapProps) {
    return useMemo(() => {
        const map = {}
             if (!data) return map
             if (!Array.isArray(data)) return map
             for (let i = 0; i < data.length; i++) {
                 const { key, value } = data[i]
                 map[key] = value
             }
             return map
    }, [data])
}
